import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import { LoadingButton } from "@material-ui/lab";
import { useMemo } from "react";
import AppTablaDetalleDistribucionClientes from "src/components/estadisticas/app-tabla-detalle-distribucion-clientes";
import ExportToExcel from "src/components/ExportToExcel";
import PropTypes from "prop-types";
import {
  capitalizarPalabras,
  capitalizarPrimeraLetra,
} from "src/utils/sharedFunctions";
import { fDateLong } from "src/utils/formatTime";
import { fNumber, formatAsCLP } from "src/utils/formatNumber";
import { formatRut, RutFormat } from "@fdograph/rut-utilities";

// Replica el formato de precio de la tabla: CLP con símbolo, USD/EUR con sufijo.
const formatearPrecio = (valor, tipoMoneda) => {
  if (tipoMoneda === "PESOS") return formatAsCLP(valor);
  if (tipoMoneda === "DOLAR") return `${fNumber(valor)}USD`;
  if (tipoMoneda === "EURO") return `${fNumber(valor)}EUR`;
  return `${valor}${tipoMoneda ?? ""}`;
};

// Aplana cada cliente en una fila por servicio (history), repitiendo los datos
// del cliente. Los clientes sin servicios igual quedan con una fila.
const construirFilasDetalle = (clientes) =>
  (clientes ?? []).flatMap((cliente) => {
    const datosCliente = {
      rut: formatRut(cliente.rut, RutFormat.DOTS_DASH),
      cliente: capitalizarPrimeraLetra(cliente.cliente),
      fechaIngreso: fDateLong(cliente.fechaIngreso),
    };
    const historial = cliente.history ?? [];
    if (historial.length === 0) {
      return [
        {
          ...datosCliente,
          servicio: "",
          tipo: "",
          fechaCreacion: "",
          sucursal: "",
          precio: "",
        },
      ];
    }
    return historial.map((item) => ({
      ...datosCliente,
      servicio: capitalizarPalabras(item.nombre),
      tipo: item.tipo,
      fechaCreacion: fDateLong(item.fechaCreacion),
      sucursal: capitalizarPalabras(item.sucursal),
      precio: formatearPrecio(item.valor, item.tipoMoneda),
    }));
  });

const ModalDetalleDivisionClientes = ({
  isOpen,
  setOpen,
  title,
  detalleDivisionclientes,
  cargandoDetalleDivisionClientes,
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  const filasExcel = useMemo(
    () => construirFilasDetalle(detalleDivisionclientes),
    [detalleDivisionclientes],
  );

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="dialog-modal-detalle-division-clientes"
      id="dialog-modal-detalle-division-clientes"
      fullWidth
      maxWidth="xl"
    >
      <DialogTitle htmlFor="dialog-modal-detalle-division-clientes">
        {title}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12}>
            <AppTablaDetalleDistribucionClientes
              loading={cargandoDetalleDivisionClientes}
              title="Detalle clientes"
              rows={
                !cargandoDetalleDivisionClientes && detalleDivisionclientes
                  ? detalleDivisionclientes
                  : []
              }
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ExportToExcel
          data={filasExcel}
          filename={title || "Detalle clientes"}
          sheetName="Clientes"
          type="objects"
          disabled={cargandoDetalleDivisionClientes || filasExcel.length === 0}
        />
        <LoadingButton onClick={handleClose} color="error">
          Cerrar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

ModalDetalleDivisionClientes.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  setOpen: PropTypes.func,
  detalleDivisionclientes: PropTypes.array,
  cargandoDetalleDivisionClientes: PropTypes.bool,
};

export default ModalDetalleDivisionClientes;
